import axios from "@/config/axios";
export default {
    //预约咨询
    email_hehuiyu_add: data => axios.post("/index.php/Home/index/email_hehuiyu_add", data),
};